module.exports = __webpack_public_path__ + "img/level-up-alt.cc1fea7c.svg";